import { LeoRPCResult, parseResponse } from "@surya-digital/leo-ts-types";
import { APIClient, Request, Method } from "@surya-digital/tedwig";
import { GetPresignedDocumentUploadURLForRespondentSpocMappingRPC } from "./getPresignedDocumentUploadUrlForRespondentSpocMappingRPC";

export class GetPresignedDocumentUploadURLForRespondentSpocMappingRPCClientImpl extends GetPresignedDocumentUploadURLForRespondentSpocMappingRPC {
  readonly client: APIClient;

  constructor(client: APIClient) {
    super();
    this.client = client;
  }

  async execute(request: GetPresignedDocumentUploadURLForRespondentSpocMappingRPC.Request): Promise<LeoRPCResult<GetPresignedDocumentUploadURLForRespondentSpocMappingRPC.Response, GetPresignedDocumentUploadURLForRespondentSpocMappingRPC.Errors.Errors>> {
    const requestBody = request.toDTO();
    const response = await this.client.sendRequest(
      new Request(
        Method.Post,
        "spoc-management/GetPresignedDocumentUploadURLForRespondentSpocMapping",
        undefined,
        undefined,
        requestBody
      )
    );
    return parseResponse<
      GetPresignedDocumentUploadURLForRespondentSpocMappingRPC.ResponseDTO,
      GetPresignedDocumentUploadURLForRespondentSpocMappingRPC.Errors.ErrorsDTO,
      GetPresignedDocumentUploadURLForRespondentSpocMappingRPC.Response,
      GetPresignedDocumentUploadURLForRespondentSpocMappingRPC.Errors.Errors
    >(
      response,
      "spoc-management/GetPresignedDocumentUploadURLForRespondentSpocMapping",
      GetPresignedDocumentUploadURLForRespondentSpocMappingRPC.Response.fromDTO,
      GetPresignedDocumentUploadURLForRespondentSpocMappingRPC.Errors.fromDTO
    );
  }
}
